import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "usl_admin_token";
const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY) || ""}` });

export function Appraisals() {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    try { const { data } = await axios.get(`${API}/admin/appraisals`, { headers: authHeader() }); setItems(data); }
    catch { toast.error("Failed to load."); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-4">
      {items.length === 0 ? <div data-testid="appraisals-empty" className="p-10 text-center text-[#9BA39B] text-sm border border-[#F4EFE6]/10 bg-[#11171A]">No appraisals yet. The &quot;What&apos;s my land worth&quot; tool feeds this list.</div> : items.map(a => (
        <details key={a.id} data-testid={`appraisal-${a.id}`} className="border border-[#F4EFE6]/10 bg-[#11171A] p-6">
          <summary className="cursor-pointer flex items-baseline justify-between gap-4">
            <div>
              <div className="font-semibold text-[#F4EFE6]">{a.name} <span className="text-[#9BA39B] font-normal">· {a.postcode.toUpperCase()} · {a.acreage}</span></div>
              <div className="text-[11px] text-[#9BA39B] mt-1">{a.email}{a.phone ? ` · ${a.phone}` : ""} · {a.intended_use}</div>
            </div>
            <span className="text-[10px] tracking-[0.22em] uppercase text-[#C9A24B] font-semibold">{new Date(a.created_at).toLocaleDateString("en-GB")}</span>
          </summary>
          <pre className="mt-4 text-xs text-[#E8E1D2] whitespace-pre-wrap leading-relaxed">{a.report}</pre>
          {a.notes && <div className="mt-3 text-xs text-[#9BA39B]"><strong>User notes:</strong> {a.notes}</div>}
        </details>
      ))}
    </div>
  );
}

export function Suppressions() {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    try { const { data } = await axios.get(`${API}/admin/suppressions`, { headers: authHeader() }); setItems(data); }
    catch { toast.error("Failed to load."); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="border border-[#F4EFE6]/10 bg-[#11171A]">
      <div className="grid grid-cols-12 gap-3 px-5 py-3 text-[10px] tracking-[0.24em] uppercase text-[#9BA39B] font-semibold border-b border-[#F4EFE6]/10">
        <div className="col-span-3">Code</div>
        <div className="col-span-3">Postcode / Email</div>
        <div className="col-span-4">Address / Reason</div>
        <div className="col-span-2">When</div>
      </div>
      {items.length === 0 ? (
        <div data-testid="suppressions-empty" className="p-10 text-center text-[#9BA39B] text-sm">No suppressions on file. (Anyone using /unsubscribe will appear here.)</div>
      ) : items.map(s => (
        <div key={s.id} data-testid={`suppression-${s.id}`} className="grid grid-cols-12 gap-3 px-5 py-4 items-center text-sm border-b border-[#F4EFE6]/10">
          <div className="col-span-3 font-mono text-[#C9A24B] tracking-wider text-[12px]">{s.code || "—"}</div>
          <div className="col-span-3 text-[#E8E1D2]">{s.postcode?.toUpperCase()}{s.email ? ` · ${s.email}` : ""}</div>
          <div className="col-span-4 text-[#9BA39B] text-[12px]">{s.address || "—"}{s.reason ? ` · ${s.reason}` : ""}</div>
          <div className="col-span-2 text-[11px] text-[#9BA39B]">{new Date(s.created_at).toLocaleDateString("en-GB")}</div>
        </div>
      ))}
    </div>
  );
}
